import request from '@/utils/request'

export function overview(params) {
  return request({
    url: '/dashboard/overview',
    method: 'get',
    params
  })
}

export function costList(params) {
  return request({
    url: '/dashboard/cost-list',
    method: 'get',
    params
  })
}

export function notifyDetail(params) {
  return request({
    url: '/dashboard/notify-detail',
    method: 'get',
    params
  })
}

export function notifyList(params) {
  return request({
    url: '/dashboard/notify-list',
    method: 'get',
    params
  })
}
export function notifyRead(data) {
  return request({
    url: '/dashboard/notify-read',
    method: 'post',
    data
  })
}
export function notifyUnreadList(params) {
  return request({
    url: '/dashboard/notify-unread-list',
    method: 'get',
    params
  })
}
export function notifyUnreadListForPopup(params) {
  return request({
    url: '/dashboard/notify-unread-list-for-popup',
    method: 'get',
    params
  })
}
export function notifyClear() {
  return request({
    url: '/dashboard/notify-clear',
    method: 'post'
  })
}
export function notifyMarkAllRead() {
  return request({
    url: '/dashboard/notify-mark-all-read',
    method: 'post'
  })
}
export function querySummary(params) {
  return request({
    url: '/dashboard/summary',
    method: 'get',
    params
  })
}

export function unpaidOrderList(params) {
  return request({
    url: '/dashboard/unpaid-order-list',
    method: 'get',
    params
  })
}

/**
 * 求评漏斗 → 服务端 GA4
 * type=open → dashboard_open（打开 Dashboard，eligible=有 Shopify 店且有过签收）
 * type=show → app_review_prompt_show
 * type=click + action=leave_review|later|never|dismiss → app_review_click
 * extra.source：dashboard_prompt（Dashboard 弹窗）/ navbar（顶部常驻入口）
 */
export function trackAppReviewEvent(type, action, extra) {
  const data = { type }
  if (action) data.action = action
  if (extra && extra.eligible != null) data.eligible = extra.eligible
  if (extra && extra.source) data.source = extra.source
  return request({
    url: '/dashboard/app-review-event',
    method: 'post',
    data
  })
}


